﻿import TKCustomElementFactory from '@tk/utilities/tk.custom.element.factory';

export default class TKFilterSelectReset extends TKCustomElementFactory {
    wrapper?: HTMLElement;
    button?: HTMLButtonElement;

    constructor() {
        super();

        this.wrapper = this.closest('[data-tk-filter-dropdown]') || undefined;
        this.button = this.querySelector('button') || undefined;
    }

    connectedCallback(): void {
        if (!this.button) throw new Error('Select Reset: Button is missing!');

        this.registerClickListener();
    }

    registerClickListener() {
        const onClick = this.reset.bind(this);
        this.pushListener({ event: 'click', element: this.button!, action: onClick });
    }

    reset() {
        const fiterTypes = this.wrapper!.querySelector<HTMLElement>('[data-tk-filter-types]');
        if (!fiterTypes) return;
        const { children } = fiterTypes;
        const childList = Array.from(children);
        childList.forEach((child) => {
            const input = child.querySelector('input');
            if (!input) return;
            input.checked = false;
        });
    }
}
